<template>
  <div class="home kzFont rtl">
    <el-container>
      <el-aside width="auto">
        <div class="sidebar-logo-container" :class="{ collapse: isCollapse }">
          <transition name="sidebarLogoFade">
            <router-link
              v-if="isCollapse"
              key="isCollapse"
              class="sidebar-logo-link"
              to="/"
            >
              <img v-if="logo" :src="logo" class="sidebar-logo logo-mini" />
              <h1 v-else class="sidebar-title">{{ title }}</h1>
            </router-link>
            <router-link v-else key="expand" class="sidebar-logo-link" to="/">
              <img v-if="logo" :src="logo" class="sidebar-logo" />
              <h1 class="sidebar-title">{{ title }}</h1>
            </router-link>
          </transition>
        </div>
        <el-menu
          :collapse="isCollapse"
          :default-active="$route.path"
          unique-opened
          class="el-menu-admin rtl kzFont"
          background-color="#2B303B"
          text-color="#fff"
          active-text-color="#409EFF"
          :router="true"
          v-if="menus"
        >
          <div v-for="(item, index) in menus" :key="index">
            <el-submenu
              :index="item.path"
              v-if="item.children && item.children.length > 0"
            >
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group
                class="kzFont rtl"
                :index="child.path"
                v-for="(child, ind) in item.children"
                :key="ind"
              >
                <el-menu-item :index="child.path">
                  <i :class="child.icon"></i>
                  <span slot="title">{{ child.name }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item :index="item.path" v-else>
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </div>
        </el-menu>
        <!-- <router-link
          v-if="!isCollapse"
          style="
            text-align: center;
            color: #fff;
            margin: auto 20px;
            line-height: 50px;
          "
          class="sidebar-logo-link"
          to="/about"
        >
          سەستاما تۋرالى
        </router-link> -->
        <exit :collapse="isCollapse" />
      </el-aside>
      <el-container>
        <el-main>
          <hamburger
            id="hamburger-container"
            :is-active="isCollapse"
            class="hamburger-container"
            @toggleClick="isCollapse = !isCollapse"
          />
          <router-view></router-view>
        </el-main>
        <!-- <el-footer>سەستامانى جاساعان: ارنا توراپتىق قىزمەت وتەۋ جۇيەسى</el-footer> -->
      </el-container>
    </el-container>
  </div>
</template>
<script>
import logoImg from '@/assets/avatar.png'
import { menus } from './menus'
import Hamburger from '@/components/Hamburger'
import Exit from '@/components/Exit'

export default {
  components: {
    Hamburger,
    Exit
  },
  data () {
    return {
      title: 'الاتاۋ',
      isCollapse: false,
      activerouter: '',
      menus: menus,
      userinfo: {
        avatar: localStorage.getItem('avatar'),
        nickname: localStorage.getItem('nickname')
      },
      logo: logoImg
    }
  },
  computed: {
    onRoutes () {
      let path = this.$route.path.replace('/', '')
      return path || '/'
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('token')
      localStorage.removeItem('nickname')
      localStorage.removeItem('avatar')
      this.$message({
        message: 'شەگىنۋ ءساتتى بولدى',
        type: 'warning',
        customClass: 'kzFont rtl'
      })
      setTimeout(() => {
        this.$router.push({ name: 'login' })
      }, 3000)
    },
    handleCommand (command) {
      if (command === 'logout') {
        this.logout()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button > span {
  margin: 5px 0 0 !important;
}
.home {
  height: 100%;
  background-color: #fff;
  .el-menu-admin:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .el-menu {
    border-right: none;
    flex-grow: 1;
  }
  .el-container {
    height: 100%;
  }
  .el-aside {
    background-color: #2b303b;
  }
  .el-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #2b303b;
  }
  .logo {
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    text-align: center;
    color: #fff;
    border-bottom: 1px solid #6a6e73;
    width: auto;
  }
  .toggle-btn {
    padding: 0 10px;
    margin-left: -20px;
    font-size: 36px;
    line-height: 60px;
    color: white;
    cursor: pointer;
    &:hover {
      background-color: #00635a;
    }
  }
  .system-title {
    font-size: 24px;
    color: white;
  }
  .welcome {
    color: white;
  }
  .d-flex {
    display: flex;
    align-items: center;
    width: 232px;
    justify-content: space-around;
  }
}

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 140px;
  line-height: 140px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;
  box-sizing: border-box;

  & .sidebar-logo-link {
    padding-top: 10px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    & .sidebar-logo {
      width: 46px;
      height: 46px;
      vertical-align: middle;
      border-radius: 50%;
    }

    & .logo-mini {
      width: 40px;
      height: 40px;
      vertical-align: middle;
      border-radius: 50%;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 16px 0 0;
      padding: 0;
      font-size: 18px;
      text-align: left;
      color: #ffffff;
      line-height: 25px;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
.hideSidebar {
  .sidebar-logo-container {
    height: 130px;
    line-height: 130px;
  }
  .sidebar-logo-link {
    justify-content: flex-start;
    padding-top: 36px;
  }
}

.el-footer {
  background-color: #f5f5f5;
  color: #333;
  text-align: center;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue